/* ============================================================
   SNKRS UNIVERSE – Carousel + Bottom Sheet JS R43 FINAL
   - Variant price updates
   - Size selection with confirmation button
   - Full cart drawer integration
============================================================ */

document.addEventListener("DOMContentLoaded", () => {

  const isDesktop = window.matchMedia("(pointer: fine)").matches;

  /* -----------------------------
     CART HELPERS
  ------------------------------ */
  const updateCartBubble = (html) => {
    const bubble = document.querySelector("#cart-icon-bubble");
    if (!bubble) return;

    const doc = new DOMParser().parseFromString(html, "text/html");
    const sect = doc.querySelector(".shopify-section");
    if (sect) bubble.innerHTML = sect.innerHTML;
  };

  const updateCartDrawer = async () => {
    try {
      const res = await fetch(`/?sections=cart-drawer,cart-icon-bubble&t=${Date.now()}`, {
        cache: "no-store",
        credentials: "same-origin"
      });

      const sections = await res.json();
      const drawer = document.querySelector("cart-drawer");

      if (drawer && typeof drawer.renderContents === "function") {
        drawer.renderContents({ id: Date.now(), sections });

        drawer.classList.remove("is-empty");
        if (typeof drawer.open === "function") drawer.open();
      }

      if (sections["cart-icon-bubble"]) updateCartBubble(sections["cart-icon-bubble"]);

    } catch (err) {
      console.error("[SNKRS] Drawer Update Fehler:", err);
    }
  };

  const addToCartByVariantId = async (variantId) => {
    try {
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        credentials: "same-origin"
      });

      if (!addRes.ok) throw new Error("Add-to-cart fehlgeschlagen");

      await updateCartDrawer();

    } catch (err) {
      console.error("[SNKRS] Add-to-cart Fehler:", err);
    }
  };

  /* -----------------------------
     BOTTOM SHEET
  ------------------------------ */
  const bottomSheet   = document.getElementById("snkrs-bottom-sheet");
  const sheetBackdrop = bottomSheet?.querySelector(".snkrs-bottom-sheet__backdrop");
  const sheetPanel    = bottomSheet?.querySelector(".snkrs-bottom-sheet__panel");

  const openBottomSheet = () => {
    bottomSheet.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };

  const closeBottomSheet = () => {
    bottomSheet.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  sheetBackdrop?.addEventListener("click", closeBottomSheet);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeBottomSheet();
  });


  /* -----------------------------
     CLICK ON .price-cart
  ------------------------------ */
  document.body.addEventListener("click", async (e) => {
    const btn = e.target.closest(".price-cart");
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const handle = btn.dataset.productHandle;
    const variantId = btn.dataset.variantId;
    const hasMultiple = btn.dataset.hasMultiple === "true";

    try {
      // one variant only
      if (!hasMultiple && variantId) {
        await addToCartByVariantId(variantId);
        return;
      }

      // multiple variants → open selector
      const res = await fetch(`/products/${handle}.js`, { cache: "no-store" });
      if (!res.ok) throw new Error("Produkt nicht gefunden");

      const product = await res.json();
      const variants = product.variants || [];

      if (variants.length <= 1) {
        await addToCartByVariantId(variants[0].id);
        return;
      }

      /* -----------------------------
         R43 — BUILD BOTTOM SHEET
      ------------------------------ */
      const mainImg = product.images?.[0] || "";

      sheetPanel.innerHTML = `
        <div class="snkrs-bs-header">
          <img src="${mainImg}" class="snkrs-bs-img-full" alt="">
          <h3 class="snkrs-bs-title">${product.title}</h3>
          <p class="snkrs-bs-price main-price">${(product.price / 100).toFixed(2)} €</p>

<p class="snkrs-bs-subprice">${product.price_min !== product.price_max 
  ? "ab " + (product.price_min / 100).toFixed(2) + " €"
  : ""}</p>

          <div class="snkrs-bs-close">×</div>
        </div>

        <h3 class="snkrs-size-title">Größe wählen</h3>

        <div class="snkrs-size-grid">
          ${variants
            .map(v => {
              const size = v.option1;
              const price = (v.price / 100).toFixed(2) + " €";

              if (!v.available) {
                return `
                  <button class="snkrs-size-btn unavailable" disabled>
                    ${size}
                  </button>`;
              }

              return `
                <button class="snkrs-size-btn"
                  data-variant-id="${v.id}"
                  data-price="${price}">
                  <span>${size}</span>
                  <small>${price}</small>
                </button>`;
            })
            .join("")}
        </div>

        <button class="snkrs-add-btn disabled" disabled>
          Größe wählen
        </button>
      `;

      sheetPanel.querySelector(".snkrs-bs-close")
        .addEventListener("click", closeBottomSheet);

      /* -----------------------------
         R43 SIZE SELECTION LOGIC
      ------------------------------ */
      let selectedVariantId = null;

      const sizeBtns = sheetPanel.querySelectorAll(".snkrs-size-btn:not(.unavailable)");
      const addBtn = sheetPanel.querySelector(".snkrs-add-btn");
      const priceEl = sheetPanel.querySelector(".main-price");

      sizeBtns.forEach(btn => {
        btn.addEventListener("click", () => {
          sizeBtns.forEach(b => b.classList.remove("selected"));
          btn.classList.add("selected");

          selectedVariantId = btn.dataset.variantId;
          const newPrice = btn.dataset.price;
          priceEl.textContent = newPrice;

          addBtn.textContent = `In den Warenkorb – ${newPrice} - Gr. ${btn.querySelector("span").textContent}`;

          addBtn.classList.remove("disabled");
          addBtn.disabled = false;
        });
      });

      addBtn.addEventListener("click", async () => {
        if (!selectedVariantId) return;

        addBtn.classList.add("loading");
        addBtn.textContent = "Wird hinzugefügt…";

        await addToCartByVariantId(selectedVariantId);

        closeBottomSheet();
      });

      openBottomSheet();

    } catch (err) {
      console.error("[SNKRS] price-cart Fehler:", err);
    }
  });


  /* -----------------------------------------------------------
     CAROUSEL (R40 unverändert)
  ------------------------------------------------------------ */
  document.querySelectorAll(".snkrs-carousel").forEach((section) => {
    const track    = section.querySelector(".carousel-track");
    const btnLeft  = section.querySelector(".carousel-arrow.left");
    const btnRight = section.querySelector(".carousel-arrow.right");

    if (!track) return;

    const updateButtons = () => {
      const max = track.scrollWidth - track.clientWidth;
      const x = track.scrollLeft;

      if (btnLeft) {
        btnLeft.style.opacity = x <= 5 ? "0" : "1";
        btnLeft.style.pointerEvents = x <= 5 ? "none" : "auto";
      }

      if (btnRight) {
        btnRight.style.opacity = x >= max - 5 ? "0" : "1";
        btnRight.style.pointerEvents = x >= max - 5 ? "none" : "auto";
      }
    };

    track.addEventListener("scroll", () => requestAnimationFrame(updateButtons));
    window.addEventListener("resize", updateButtons);
    updateButtons();

    const scrollStep = 340;
    const scrollCarousel = (dir) => {
      const max = track.scrollWidth - track.clientWidth;
      const cur = track.scrollLeft;
      const rest = dir === "right" ? max - cur : cur;
      const step = Math.min(rest, scrollStep);

      if (step > 0) {
        track.scrollBy({
          left: dir === "right" ? step : -step,
          behavior: "smooth",
        });
        setTimeout(updateButtons, 300);
      }
    };

    btnLeft?.addEventListener("click", () => scrollCarousel("left"));
    btnRight?.addEventListener("click", () => scrollCarousel("right"));
  });

});
